import { logUsage } from 'owa-analytics';
import type { CustomData } from 'owa-analytics-types';

export default function logSpacesDatapoint(eventName: string, customData?: CustomData) {
    logUsage(eventName, customData ? customData : {});
}
